<ng-content select="input[type='checkbox']"></ng-content>
